/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedTileindexListResponse } from '../types/PaginatedTileindexList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type TileindexesListRequest = {} | null | undefined;
export type TileindexesListResponse = PaginatedTileindexListResponse;

export type TileindexesListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/tileindexes/
 *
 * ```yaml
 * operationId: tileindexes_list
 * tags:
 *   - tileindexes
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedTileindexList'
 *     description: ''
 * ```
 */
export const tileindexesListOperation = (rest?: TileindexesListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/tileindexes/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/tileindexes/' };
  };

/**
 * GET /dmx-server/tileindexes/
 *
 * ```yaml
 * operationId: tileindexes_list
 * tags:
 *   - tileindexes
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedTileindexList'
 *     description: ''
 * ```
 */
export const tileindexesList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: TileindexesListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedTileindexListResponse>> => {
  const operation = tileindexesListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/tileindexes/
 */
export const useTileindexesListResource = (
  query: TileindexesListQuery | null,
  useCached?: boolean,
): UseResource<TileindexesListResponse> => {
  return useResource<TileindexesListResponse>({
    path: query === null ? null : tileindexesListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
